export const SESSION_STORAGE_KEYS = {
  UCS_IS_DIGITAL_ONLY_CARD: 'ucsIsDigitalOnlyCard',
  UCS_TOAST_MESSAGES: 'ucsToastMessages',
  PAGE_ALERTS: 'pageAlerts',
  PPDC_GET_CARD_CLICKED: 'ppdcGetCardClicked',
}
